<div class="backdrop" [class.backdrop_show]="visible">
  <div class="a-activity-indicator" aria-live="off">
    <div class="a-activity-indicator__top-box"></div>
    <div class="a-activity-indicator__bottom-box"></div>
  </div>
</div>
